import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import { AppSidebar } from "@/app/(main)/dashboard/_components/sidebar/app-sidebar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AuthGuard } from "@/components/auth-guard";
import { EnvironmentPill } from "@/components/environment-pill";
import { getCookie, getPreference } from "@/lib/cookies";
import {
  SIDEBAR_VARIANT_VALUES,
  SIDEBAR_COLLAPSIBLE_VALUES,
  type SidebarVariant,
  type SidebarCollapsible,
} from "@/types/preferences/layout";

export function DashboardLayout() {
  const [defaultOpen, setDefaultOpen] = useState(false);
  const [sidebarVariant, setSidebarVariant] = useState<SidebarVariant>('inset');
  const [sidebarCollapsible, setSidebarCollapsible] = useState<SidebarCollapsible>('icon');

  useEffect(() => {
    // Get sidebar preferences from cookies on mount
    const sidebarState = getCookie("sidebar_state") === "true";
    const variant = getPreference<SidebarVariant>("sidebar_variant", SIDEBAR_VARIANT_VALUES, "inset");
    const collapsible = getPreference<SidebarCollapsible>("sidebar_collapsible", SIDEBAR_COLLAPSIBLE_VALUES, "icon");
    
    setDefaultOpen(sidebarState);
    setSidebarVariant(variant);
    setSidebarCollapsible(collapsible);
  }, []);

  return (
    <AuthGuard>
      <SidebarProvider defaultOpen={defaultOpen}>
        <AppSidebar variant={sidebarVariant} collapsible={sidebarCollapsible} />
        <SidebarInset className="h-screen max-h-screen overflow-y-auto">
          <header className="sticky top-0 z-10 flex h-14 shrink-0 items-center gap-2 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-6 md:rounded-t-xl">
            <SidebarTrigger className="-ml-1" />
            <div className="ml-auto -mr-2">
              <EnvironmentPill />
            </div>
          </header>
          <main>
            <div className="container mx-auto p-6 lg:p-8 max-w-[1600px]">
              <Outlet />
            </div>
          </main>
        </SidebarInset>
      </SidebarProvider>
    </AuthGuard>
  );
}
